<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <Transition name="fade" mode="out-in">
        <component :is="Component" :environment="environment" />
      </Transition>
    </router-view>
  </div>
</template>

<script>

import axios from 'axios';
import Url from '@/core/Url.js'
import Environment from '@/core/Environment.js'

export default {
  name: 'App',
  data () {
    return {
      environment : null,
    };
  },
  methods: {
    initEnvironment () {
      this.environment = Environment.getDefault();
      axios
          .get(Url.getEnvironmentUrl())
          .then(response => {
            if (response.data.result && response.data.data) {
              this.environment = response.data.data;
            }
          });
    }
  },
  created () {
    this.initEnvironment ();
  }
}

</script>

<style>

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.4s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }

</style>
